export default "__VITE_ASSET__CaO74sz4__"